import { AnimatePresence, motion } from "framer-motion";
import GreenScreenVideo from "@/components/GreenScreenVideo";

/* দোকান-প্রতিনিধি 'চিত্রা' — চ্যাটবক্স নয়, দৃশ্যের ভেতরেই দাঁড়িয়ে থাকা মানুষ */
export default function ShopRep({ line, chips, busy, onChip, onSend, voiceOn, onToggleVoice, lipVideo, onVideoError, inputOpen, onInputOpen }) {
  return (
    <div className="flex flex-row items-end gap-2 sm:gap-5" data-testid="shop-rep">
      {/* কথার বুদবুদ */}
      <div className="mb-6 w-[168px] shrink-0 sm:mb-10 sm:w-[300px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={line}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.35 }}
            className="relative rounded-2xl rounded-br-sm border border-gold/30 bg-plaster/95 px-4 py-3 text-[12.5px] leading-relaxed whitespace-pre-line text-sand shadow-[0_18px_50px_rgba(0,0,0,0.5)] backdrop-blur-md sm:text-sm"
            data-testid="rep-bubble"
          >
            {busy ? (
              <span className="flex gap-1 py-1" data-testid="rep-typing">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gold" />
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gold [animation-delay:0.2s]" />
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gold [animation-delay:0.4s]" />
              </span>
            ) : (
              line
            )}
            <button
              data-testid="rep-voice-toggle"
              onClick={onToggleVoice}
              aria-label={voiceOn ? "গলা বন্ধ করুন" : "গলা চালু করুন"}
              className="absolute -top-2.5 -right-2.5 flex h-6 w-6 items-center justify-center rounded-full border border-gold/30 bg-dusk/90 text-gold/80 transition-colors hover:text-gold"
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M11 5 6 9H3v6h3l5 4V5Z" />
                {voiceOn ? <path d="M15.5 8.5a5 5 0 0 1 0 7" /> : <path d="m16 9 6 6M22 9l-6 6" />}
              </svg>
            </button>
          </motion.div>
        </AnimatePresence>

        <div className="mt-2.5 flex flex-wrap gap-1.5 sm:gap-2" data-testid="rep-chips">
          {chips.map((c, ci) => (
            <button
              key={c.label}
              data-testid={`rep-chip-${c.action || "send"}-${ci}`}
              onClick={() => onChip(c)}
              className="rounded-full border border-gold/35 bg-dusk/70 px-3 py-1.5 text-[11px] text-gold backdrop-blur-md transition-all duration-300 hover:bg-gold hover:text-dusk sm:text-xs"
            >
              {c.label}
            </button>
          ))}
        </div>

        {(inputOpen || chips.length === 0) && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const el = e.currentTarget.elements.namedItem("repinput");
              if (el && el.value.trim()) {
                onSend(el.value);
                el.value = "";
              }
            }}
            className="mt-2 flex items-center gap-2 rounded-full border border-gold/25 bg-plaster/95 py-1.5 pr-1.5 pl-3.5 shadow-lg backdrop-blur-md"
          >
            <input
              name="repinput"
              data-testid="rep-input"
              placeholder="মনের কথা লিখুন — যেমন ₹1,700 হলে নেব…"
              className="min-w-0 flex-1 bg-transparent text-[11px] text-sand placeholder:text-sand/40 focus:outline-none sm:text-xs"
            />
            <button
              type="submit"
              data-testid="rep-send"
              disabled={busy}
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-vermilion text-alpana transition-transform duration-300 hover:scale-105 disabled:opacity-50"
              aria-label="পাঠান"
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z" />
              </svg>
            </button>
          </form>
        )}
      </div>

      {/* অবয়ব */}
      <div className="relative aspect-[2/3] w-[140px] shrink-0 sm:w-[220px] lg:w-[280px]" data-testid="rep-figure">
        <div className="absolute inset-x-8 bottom-1 h-4 rounded-[100%] bg-black/45 blur-md" />
        {lipVideo ? (
          <GreenScreenVideo src={lipVideo} muted={false} onError={onVideoError} className="figure-feather h-full w-full" />
        ) : (
          <img src="/shop-rep-figure.png" alt="চিত্রা" data-testid="rep-figure-img" className="figure-feather absolute inset-0 h-full w-full object-contain object-bottom" />
        )}
      </div>
    </div>
  );
}
